import React from 'react';
import { Card, List, Avatar, Button } from 'antd';
import { UserOutlined, GiftOutlined } from '@ant-design/icons';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

interface AnniversaryPerson {
    userId: string;
    displayName: string;
    countryName: string;    
}

interface AnniversaryWidgetProps {
    currentMonth: string;
    anniversarys: AnniversaryPerson[];
    userProfileImages: { [key: string]: string | null };
}

const WorkAnniversaryWidget: React.FC<AnniversaryWidgetProps> = ({
    currentMonth,
    anniversarys,
    userProfileImages
}) => {
    const groupedanniversary = anniversarys.reduce((acc: { [key: string]: AnniversaryPerson[] }, person) => {
        //const date = person.birthday.split('T')[0].split('-')[2]; 
        const date = Date.now.toString().split('T')[0].split('-')[2];
        if (!acc[date]) {
            acc[date] = [];
        }
        acc[date].push(person);
        return acc;
    }, {});

    const sortedDates = Object.keys(groupedanniversary).sort((a, b) => parseInt(a) - parseInt(b));
    const { t } = useTranslation();

    return (
        <Card
            title={
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <GiftOutlined style={{ marginRight: '8px', color: '#ff4d4f' }} />
                    <span>{t('work_anniversary_in')} {currentMonth}</span>
                    <span role="img" aria-label="trophy" style={{ marginLeft: '5px' }}>🏆</span>
                </div>
            }
            style={{
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                borderRadius: '8px',
                marginTop: '20px'
            }}
        >
            {sortedDates.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                    No Work Anniversary data available.
                </div>
            ) : (
                sortedDates.map(date => (
                    <div key={date} style={{ marginBottom: '15px' }}>
                        <h3 style={{ borderBottom: '1px solid #f0f0f0', paddingBottom: '5px' }}>
                            {currentMonth} {moment().format('DD')}
                        </h3>
                    <List
                        itemLayout="horizontal"
                        dataSource={groupedanniversary[date]}
                        renderItem={person => (
                            <List.Item>
                                <List.Item.Meta
                                    avatar={
                                        <Avatar
                                            src={userProfileImages[person.userId] ?
                                                `data:image/jpeg;base64,${userProfileImages[person.userId]}` : undefined}
                                            icon={<UserOutlined />}
                                        />
                                    }
                                    title={person.displayName}
                                    description={person.countryName}
                                />
                            </List.Item>
                        )}
                    />
                </div>
                ))
            )}
        </Card>
    );
};

export default WorkAnniversaryWidget;
